<footer class="footer fixed flex flex-col justify-between items-center w-screen bottom-0 z-10 text-xs lg:text-sm md:flex-row">
  <div class="flex pl-4">
    <p class="caption-c2 uppercase primary-text">{{'footer.copyright' | translate}} {{currentYear}}</p>
    <p class="caption-c2 text-disabled pl-1">· V{{version}}</p>
  </div>
</footer>
